import { Component } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
  selector: 'terms-of-service',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss']
})
export class TermsComponent {
  public needAccept: boolean;
  constructor(public dialogRef: MatDialogRef<TermsComponent>) {}
}
